<template>
    <div class="cons">
        <div class="bread">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item style="cursor: pointer;" @click.native="handleBack">图书推荐</el-breadcrumb-item>
                <el-breadcrumb-item>{{info.goods_name}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="cons flx jsb">
            <div class="bookLeft">
                <div class="book-swiper-container flx jsb">
                    <!-- 整体左右布局 -->
                    <div class="thumb-list">
                        <div v-for="(item, idx) in imageList" :key="idx" class="thumb-item"
                            :class="{ active: currentIndex === idx }" @click="switchCarousel(idx)">
                            <el-image :src="$img(item)" fit="cover" lazy></el-image>
                        </div>
                    </div>
                    <!-- 右侧主大图轮播 -->
                    <el-carousel style="width: 860px;" ref="mainCarousel" :interval="0" arrow="always"
                        indicator-position="none" height="720px" @change="onCarouselChange">
                        <el-carousel-item v-for="(item, idx) in imageList" :key="idx" :name="String(idx)">
                            <el-image style="width: 100%; height: 100%" :src="$img(item)" fit="contain"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="tipLeft">
                    <div class="acintro">
                        <div class="courseDes">
                            <div class="actitles">
                                <div class="actName">
                                    图书介绍
                                </div>
                                <div class="bheng"></div>
                            </div>
                            <div class="acD" v-html="info.content"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bookRight">
                <div class="bookTop">
                    <div class="bookName" v-text="info.goods_name"></div>
                    <!-- <div class="prices flx">
                        <div class="oprice" v-text="`￥${defaultSpec.goods_price}`"></div>
                        <div class="linprice" v-if="defaultSpec.line_price * 1 > 0" v-text="`￥${defaultSpec.line_price}`"></div>
                    </div> -->
                    <div class="ips">
                        <div class="ipitem flx alc jsb">
                            <!-- <div class="ipleft flx alc">
                                <img :src="$Localimg('b1.png')" alt="" />

                            </div>
                            <div class="ipright flx alc jsb">
                                <div v-if="info.freight_price * 1 == 0">商家包邮</div>
                                <div v-if="info.freight_price * 1 != 0">
                                    运费{{info.freight_price}}元,满{{info.freight_price2}}元包邮
                                </div>
                                <i class="el-icon-arrow-right" style="visibility: hidden;"></i>
                            </div> -->
                        </div>

                        <div class="ipitem flx alc jsb">
                            <div class="ipleft">
                                <img :src="$Localimg('b2.png')" alt="" />
                            </div>
                            <div class="ipright flx alc jsb">
                                <div v-text="`${info.publisher.name}更多推荐图书`"></div>
                                <!-- <i class="el-icon-arrow-right"></i> -->
                            </div>
                        </div>

                        <div class="ipitem flx alc jsb">
                            <div class="ipleft flx alc">
                                <img :src="$Localimg('b3.png')" alt="" />
                            </div>
                            <div class="ipright flx alc jsb">
                                <div v-text="info.publishing_house.name"></div>
                                <!-- <i class="el-icon-arrow-right"></i> -->
                            </div>
                        </div>
                    </div>

                    <div class="speccon">
                        <div class="specItem" v-for="item,index in info.spec.spec_attr">
                            <div class="spname" v-text="item.group_name">

                            </div>
                            <div class="specCon flx ">
                                <div class="specit cursor" @click="choose(v,index,i)" v-for="v,i in item.spec_items"
                                    v-text="v.spec_value" :class="v.isSelect == true ?'fcAc':''">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="nums flx alc">
                        <!-- <div>
                            <el-input-number v-model="num" :min="1" :max="defaultSpec.stock_num*1" :step="1"
                                label="购买数量" size="small" @change="handleChange"></el-input-number>
                        </div> -->
                        <!-- <div class="bunybtn cursor" @click="buynow">
                            马上购买
                        </div> -->

                    </div>
                    <div class="nums flx alc" style="margin-top: 20px;">
                        <div style="visibility: hidden;">
                            <el-input-number v-model="num" :min="1" :max="defaultSpec.stock_num*1" :step="1"
                                label="购买数量" size="small" @change="handleChange"></el-input-number>
                        </div>
                        <div class="bunybtn cursor" v-text="info.collect_status == 1?'已收藏' : '收藏'" @click="collthis">
                        </div>
                    </div>
                </div>
                <div class="bookBottom">
                    <div class="bbtitle">
                        推荐图书
                    </div>
                    <div class="booksContents flx alc jsb">
                        <div class="bookItem" v-for="item,index in info.recomm_book_list" @click="toDetail(item)">
                            <div class="reImge">
                                <img :src="$img(item.avatar)" alt="" />
                            </div>
                            <div class="redetail">
                                <div class="rename single" v-text="item.goods_name">

                                </div>
                                <div class="price-wrap">
                                    <!-- 价格组件 -->
                                    <!-- <span class="price-box">
                                        <span>¥</span>
                                        <span class="int">{{p(item.default_goods_price,0) }}</span>
                                        <span class="dec">{{p(item.default_goods_price,1) }}</span>
                                    </span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 收货地址弹窗 -->
        <el-dialog custom-class="dialog-bg" :visible.sync="addressVisible" width="652px">
            <div class="tabItems flx alc" slot="title">
                <div @click="changeTab(0)" class="tabItem" :class="cur == 0?'tabAc' : ''">
                    选择收货地址
                </div>
                <div @click="changeTab(1)" class="tabItem" :class="cur == 1?'tabAc' : ''">
                    新增收货地址
                </div>
            </div>
            <div class="addressContent" v-if="cur == 0">
                <div class="flx accolki">
                    <div class="addressItem cursor flx" @click="addid = item.id"
                        :style="item.id == addid?'border:1px solid #007AFF' : ''" v-for="item,index in addressList">
                        <div class="addileft">
                            <img v-if="item.id == addid" :src="$Localimg('landuihao.png')" alt="" />
                            <img v-else :src="$Localimg('addresssssss.png')" alt="" />
                        </div>
                        <div class="addiRight">
                            <div class="aditop">
                                {{item.sheng}} {{item.shi}} {{item.qu}}
                            </div>
                            <div class="adimiddle single" v-text="item.detail"></div>
                            <div class="adibottom">
                                {{item.name}} {{item.tel2}}
                            </div>
                        </div>

                        <div class="addressmask flx alc jsb">
                            <div class="amleft flx alc">
                                <div class="circle flx alc cursor"
                                    :style="item.is_status == 1?'' : 'border:1px solid #fff'"
                                    @click.stop="srtDefault(item,index)">
                                    <img v-if="item.is_status == 1" :src="$Localimg('gselected.png')" alt="" />
                                </div>
                                <div class="cnames" style="text-align: left;margin-left: 0;">
                                    <span style="color: #fff;font-size: font-size: 14px;margin-left: 9px;"
                                        v-text="item.is_status == 1?'已设为默认地址':'设为默认地址'"></span>
                                </div>
                            </div>
                            <div class="amright flx alc">
                                <div class="amritem cursor" style="margin-right: 14px;" @click.stop="editThisAdd(item)">
                                    编辑
                                </div>
                                <div class="amritem cursor" @click.stop="delThisAdd(item)">
                                    删除
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="btnsib flx alc" style="margin-top: 30px;">
                    <div class="btni" @click="dialogVisible = true,addressVisible = false">
                        取消
                    </div>
                    <div class="btnib" @click="useThis">
                        确认
                    </div>
                </div>
            </div>

            <div class="addAddress" v-else>
                <div class="formitem flx alc">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>所在地区:</span>
                    </div>
                    <div class="ipss">
                        <el-cascader v-model="areaValue" :options="areaList" :props="areaProps" placeholder="请选择省/市/区"
                            clearable @change="handleAreaChange"></el-cascader>
                    </div>
                </div>
                <div class="formitem alc flx" style="margin-top: 20px;">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>详细地址:</span>
                    </div>
                    <div class="ipss">
                        <div class="inps">
                            <el-input placeholder="请输入详细地址" v-model="address.detail"></el-input>
                        </div>
                    </div>
                </div>

                <div class="formitem alc flx" style="margin-top: 20px;">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>收货人姓名:</span>
                    </div>
                    <div class="ipss">
                        <div class="inps">
                            <el-input placeholder="请输入收货人姓名" v-model="address.name"></el-input>
                        </div>
                    </div>
                </div>

                <div class="formitem alc flx" style="margin-top: 20px;">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>手机号码:</span>
                    </div>
                    <div class="ipss">
                        <div class="inps">
                            <el-input :maxlength="11" placeholder="请输入手机号码" v-model="address.tel"></el-input>
                        </div>
                    </div>
                </div>

                <div class="formitem alc flx" style="margin-top: 20px;">
                    <div class="finame"></div>
                    <div class="ipss flx alc">
                        <div class="circle flx alc cursor"
                            @click="address.is_status == 1?address.is_status = 0 : address.is_status = 1">
                            <img v-if="address.is_status == 1" :src="$Localimg('gselected.png')" alt="" />
                        </div>
                        <div class="cnames">
                            <span>设为默认收货地址，下单时会优先使用该地址</span>
                        </div>
                    </div>
                </div>

                <div class="btnsib flx alc">
                    <div class="btni" @click="addCancel">
                        取消
                    </div>
                    <div class="btnib" @click="addAddresss">
                        确认
                    </div>
                </div>

            </div>

        </el-dialog>

        <!-- 确认订单弹窗 -->
        <el-dialog :visible.sync="dialogVisible" width="638px">
            <span slot="title">
                <span style="font-size: 16px;color: #1a1a1a;font-weight: 600;">确认订单</span>
            </span>
            <!-- 这里是完全自定义区域，想写什么写什么 -->
            <div class="custom-dialog-content">
                <div class="part">
                    <div class="addressCon flx" v-if="addid != 0" @click="addressVisible = true,dialogVisible = false">
                        <div class="addressLeft">
                            <img :src="$Localimg('addresssssss.png')" alt="" />
                        </div>
                        <div class="addressRight flx alc jsb">
                            <div class="al">
                                <div class="alt">
                                    {{defaultAdress.sheng}} {{defaultAdress.shi}} {{defaultAdress.qu}}
                                    {{defaultAdress.detail}}
                                </div>
                                <div class="alb" style="margin-top: 10px;">
                                    {{defaultAdress.name}} {{defaultAdress.tel2}}
                                </div>
                            </div>
                            <div class="ar flx alc">
                                <span style="color: #EF4444;font-size: 14px;position: relative;top: -2px;">添加</span>
                                <i class="el-icon-arrow-right" style="font-size: 8px;"></i>
                            </div>
                        </div>
                    </div>
                    <div class="addressCon flx" v-else @click="addressVisible = true,dialogVisible = false">
                        <div class="addressLeft">
                            <img :src="$Localimg('addresssssss.png')" alt="" />
                        </div>
                        <div class="addressRight flx alc jsb">
                            <div class="al">
                                <div class="alt">
                                    请先填写地址，用于商品配送
                                </div>
                                <div class="alb" style="margin-top: 10px;">
                                    商家线下发货，有问题联系客服
                                </div>
                            </div>
                            <div class="ar flx alc">
                                <span style="color: #EF4444;font-size: 14px;position: relative;top: -2px;">添加</span>
                                <i class="el-icon-arrow-right" style="font-size: 8px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="part">
                    <div class="flx">
                        <div class="orderImg">
                            <img :src="$img(defaultSpec.spec_image)" v-if="defaultSpec.spec_image" alt="" />
                            <img :src="$img(imageList[0])" v-else alt="" />
                        </div>
                        <div class="ordernames">
                            <div class="orderName" v-text="info.goods_name"></div>
                            <div class="orderspecs" v-text="defaultSpec.spcName">

                            </div>
                            <div class="flx alc jsb" style="margin-top: 12px;">
                                <div class="orderPrices" v-text="`￥${defaultSpec.goods_price}`"></div>
                                <div>
                                    <el-input-number v-model="num" @change="handleChange" :min="1"
                                        :max="defaultSpec.stock_num*1" :step="1" label="购买数量"
                                        size="small"></el-input-number>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sendmethod flx alc jsb">
                        <div class="sdleft">
                            配送方式
                        </div>
                        <div class="sdright">
                            商家配送
                        </div>
                    </div>
                    <div class="sendmethod flx alc jsb" style="border-bottom: none;">
                        <div class="sdleft">
                            留言
                        </div>
                        <div class="sdright">
                            <input maxlength="50" type="text" v-model="remark" placeholder="给卖家留言:(50字内)" />
                        </div>
                    </div>
                </div>

                <div class="part">
                    <div class="orderTitle">
                        付款信息
                    </div>
                    <div class="goodsPrice flx jsb">
                        <div class="gpname">
                            商品金额
                        </div>
                        <div class="orderPrice" v-text="`￥${defaultSpec.goods_price}`">

                        </div>
                    </div>
                    <div class="goodsPrice flx jsb">
                        <div class="gpname">
                            运费
                        </div>
                        <div class="orderPrice" v-text="`￥${payfreight}`"></div>
                    </div>
                    <div class="totalPrice flx">
                        合计: <span style="color: #EF4444;font-size: 16px;" v-text="`￥${totalfee}`"></span>
                    </div>
                </div>

                <div class="part">
                    <div class="orderTitle">
                        选择支付方式
                    </div>
                    <div class="pays flx jsb ">
                        <div class="payItem flx alc jsb">
                            <el-radio v-model="paymethod" label="1">支付宝</el-radio>
                            <img :src="$Localimg('alipays.png')" alt="" />
                        </div>
                        <div class="payItem flx jsb alc">
                            <el-radio v-model="paymethod" label="2">微信</el-radio>
                            <img :src="$Localimg('wechats.png')" alt="" />
                        </div>
                    </div>
                </div>
                <div class="subbtn cursor" @click="suborder">
                    马上支付
                </div>
            </div>
        </el-dialog>
        <wechatpay v-if="showALert" @close="showALert=false" :type="'books'" :source="'order'" :orderNo="orderNo"
            :codeUrl="codeUrl"></wechatpay>
    </div>
</template>

<script>
    import {
        getBookDetail,
        addAddress,
        getAddressList,
        setDefaultAdd,
        delAdd,
        getAdd,
        confirmBookOrder,
        collectbook
    } from "@/api/index.js"
    import wechatpay from "@/components/wechatpay.vue"
    import areaList from '@/assets/area.json'
    export default {
        components: {
            wechatpay
        },
        data() {
            return {
                codeUrl: "",
                orderNo: "",
                showALert: false,
                address: {
                    name: "",
                    detail: "",
                    tel: "",
                    is_status: 1
                },
                // 图片数据源：thumb=缩略图，big=大图
                imageList: [],
                // 当前激活索引
                currentIndex: 0,
                info: {},
                defaultSpec: {
                    goods_price: 0
                },
                cates: [],
                num: 1,
                dialogVisible: false,
                paymethod: 0,
                payfreight: 0,
                totalfee: 0,
                remark: "",
                defaultAdress: {},
                addressVisible: false,
                cur: 0,
                addressList: [],
                addid: "",
                areaList: areaList,
                checked10: false,
                // 级联配置
                areaProps: {
                    value: 'label',
                    label: 'label',
                    children: 'children'
                },
                areaValue: [],
                defaultA: {},
                editId: "",

            }
        },
        watch: {
            $route: {
                handler(to, from) {
                    this.id = to.query.id
                    this.getDetail()
                },
                deep: true
            }
        },
        created() {
            this.id = this.$route.query.id
            this.getDetail()

        },
        methods: {
            toDetail(e) {
                let that = this
                this.$router.push({
                    path: '/bookDetail', // 写路由path
                    query: {
                        id: e.goods_id,
                        type: 1
                    }
                })
            },
            handleBack() {
                if (window.history.length > 1) {
                    this.$router.back()
                } else {
                    this.$router.push('/')
                }
            },
            collthis() {
                let that = this
                let data = that.$route.query.id
                collectbook(data).then((res) => {
                    if (res.code == 1) {
                        that.$message({
                            type: 'success',
                            message: res.msg
                        });
                        that.getDetail()
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            useThis() {
                let that = this
                that.addressList.forEach((v, i) => {
                    if (v.id == that.addid) {
                        that.defaultAdress = v
                    }
                })
                that.dialogVisible = true
                that.addressVisible = false
            },
            editThisAdd(e) {
                let that = this
                that.editId = e.id

                let data = e.id
                getAdd(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.cur = 1
                        that.address.name = res.data.name
                        that.address.is_status = res.data.is_status
                        that.address.detail = res.data.detail
                        that.areaValue.push(res.data.sheng)
                        that.areaValue.push(res.data.shi)
                        that.areaValue.push(res.data.qu)
                        that.address.tel = res.data.tel
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            delThisAdd(e) {
                let that = this
                let data = {}
                data.address_id = e.id
                that.$confirm('确定要删除该收货地址吗?', ' ', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delAdd(data).then((res) => {
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getAddList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            srtDefault(e, idx) {
                let that = this
                let data = {}
                data.address_id = e.id
                setDefaultAdd(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getAddList()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
                console.log(e)
            },
            addCancel() {
                this.cur = 0
            },
            handleAreaChange(val, selectedNodes) {
                if (!val.length) {
                    this.fullAddress = ''
                    return
                }
                // 拼接省市区文字
                this.fullAddress = selectedNodes.map(item => item.label).join('/')
                console.log('编码', val)
                console.log('省市区对象', selectedNodes)
            },
            addAddresss() {
                let that = this
                console.log(that.areaValue)
                let data = {}
                data.name = that.address.name
                data.tel = that.address.tel
                data.detail = that.address.detail
                data.is_status = that.address.is_status
                data.sheng = that.areaValue[0]
                data.shi = that.areaValue[1]
                data.qu = that.areaValue[2]
                data.address_id = that.editId
                addAddress(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.cur = 0
                        that.editId = ''
                        that.getAddList()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            handleChange(e) {
                let that = this
                that.calculate()
                console.log(e)
            },
            suborder() {
                let that = this
                let data = {}
                data.goods_id = that.id
                data.num = that.num
                data.spec_id = that.defaultSpec.spec_sku_id
                data.address_id = that.defaultAdress.id
                data.remark = that.remark
                data.pay_type = that.paymethod == 1 ? 2 : 1
                confirmBookOrder(data).then((res) => {
                    if (res.code == 1) {
                        console.log(res)
                        if (res.code == 1) {
                            that.codeUrl = res.data.code_url
                            that.orderNo = res.data.order_no
                            that.showALert = true
                        }
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            changeTab(e) {
                let that = this
                if (e == 1) {
                    that.cur = 1
                }
                if (e == 0) {
                    that.getAddList()

                }
            },
            getAddList() {
                let that = this
                that.cur = 0
                getAddressList().then((res) => {
                    if (res.code == 1) {
                        this.dialogVisible = true
                        that.addressList = res.data
                        res.data.forEach((v, i) => {
                            if (v.is_status == 1) {
                                that.addid = v.id
                                that.defaultAdress = v
                            }
                        })
                    }
                })
            },
            calculate() {
                let that = this
                if (that.defaultSpec.goods_price * that.num > that.info.freight_price2 * 1 || that.defaultSpec
                    .goods_price * that.num == that.info.freight_price2 * 1) {
                    that.payfreight = 0
                    that.totalfee = that.defaultSpec.goods_price * that.num
                } else {
                    that.payfreight = that.info.freight_price
                    that.totalfee = that.defaultSpec.goods_price * that.num + that.info.freight_price * 1
                }
            },
            buynow() {
                this.getAddList()
                this.calculate()
                
            },
            choose(item, index, i) {
                let that = this
                that.defaultSpec.specArr[index] = item.item_id + ''
                that.info.spec.spec_attr[index].spec_items.forEach((val, idx) => {
                    if (idx == i) {
                        val.isSelect = true
                        that.defaultSpec.spcName += val.spec_value + "_"
                    } else {
                        val.isSelect = false
                    }

                })

                that.info.spec.spec_list.forEach((val, idx) => {
                    if (val.spec_sku_id.toString() == that.defaultSpec.specArr.toString()) {
                        that.defaultSpec.spec_image = val.form.spec_image
                        that.defaultSpec.goods_price = val.form.goods_price
                        that.defaultSpec.line_price = val.form.line_price
                        that.defaultSpec.stock_num = val.form.stock_num

                    }
                })
                let na = ''
                that.cates.forEach((v, i) => {
                    v.spec_items.forEach((val, idx) => {
                        if (val.isSelect == true) {
                            na += v.group_name + ":" + val.spec_value + " "
                        }

                    })
                })
                that.defaultSpec.spcName = na
            },
            p(e, d) {
                const s = Number(e).toFixed(2).split('.')
                let p = {}
                p.int = s[0]
                p.dec = '.' + s[1]
                return d == 0 ? s[0] : '.' + s[1]
            },
            // 点击缩略图切换轮播
            switchCarousel(index) {
                this.currentIndex = index;
                this.$refs.mainCarousel.setActiveItem(String(index));
            },
            // 轮播左右切换时同步更新缩略图激活态
            onCarouselChange(index) {
                this.currentIndex = Number(index);
            },
            getDetail() {
                let that = this
                let data = that.id
                getBookDetail(data).then((res) => {
                    console.log("res", res)
                    if (res.code == 1) {
                        // that.defaultAdress = res.data.default_order_address
                        that.info = res.data
                        that.imageList = res.data.images
                        that.cates = res.data.spec.spec_attr
                        that.defaultSpec = res.data.spec.default_spec
                        that.defaultSpec.specArr = res.data.spec.default_spec.spec_sku_id.split("_")
                        res.data.spec.spec_attr.forEach((v, i) => {
                            v.spec_items[0].isSelect = true
                        })
                        let na = ""
                        that.info.spec.spec_attr.forEach((v, i) => {
                            v.spec_items.forEach((val, idx) => {
                                if (idx == 0) {
                                    na += v.group_name + ":" + val.spec_value + " "
                                }

                            })
                        })
                        that.defaultSpec.spcName = na
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .booksContents {
        flex-wrap: wrap;
    }

    .cons {
        /* text-align: left; */
    }

    .custom-dialog-content {
        height: 60vh;
        overflow-y: scroll;
        text-align: left;
    }

    .btnsib {
        margin-top: 297px;
        justify-content: flex-end;
        width: 100%;
    }

    .amright {
        color: #fff;
        font-size: 14px;
    }

    .addressmask {
        width: 100%;
        height: 32px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 0px 0px 9px 9px;
        box-sizing: border-box;
        padding: 0 16px;
        position: absolute;
        left: 0;
        bottom: 0;
        display: none;
    }

    .btnib {
        width: 80px;
        height: 30px;
        background: #007AFF;
        border-radius: 4px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
    }

    .btni {
        cursor: pointer;
        width: 80px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        color: #333333;
        margin-right: 14px;
    }

    .circle {
        width: 18px;
        height: 18px;
        border: 1px solid #007AFF;
        border-radius: 50%;
        margin-right: 10px;
    }

    .circle img {
        width: 100%;
        height: 100%;
    }

    .cnames {
        font-size: 14px;
        color: #007AFF;
    }

    .el-dialog__header {
        background-color: #fff !important;
    }

    :deep(.dialog-bg .el-dialog__body) {
        background: #ffffff;
        /* 内容区域背景 */
    }

    :deep(.dialog-bg .el-dialog) {
        background: #ffffff;
        /* 整个弹窗（含标题栏）背景 */
    }

    .el-cascader {
        width: 100% !important;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .tis .tiitem {
        font-size: 12px;
        color: #838383;
        text-align: left;
        line-height: 24px;
        margin-left: 20px;
    }

    .finame {
        margin-right: 20px;
        font-size: 14px;
        color: #48576A;
        width: 85px;
        text-align: right;
    }

    .ipss {
        flex: 1;
    }

    .ipss .inps {
        width: 100%;
        height: 46px;
    }

    .addAddress {
        background: #fff;
        box-sizing: border-box;
        padding: 0 30px;
    }

    .addiRight {
        flex: 1;
    }

    .adibottom {
        font-size: 12px;
        color: #000000;
    }

    .aditop {
        font-size: 12px;
        color: #000000;
        margin-bottom: 6px;
    }

    .adimiddle {
        font-weight: 600;
        font-size: 14px;
        color: #1A1A1A;
        margin-bottom: 6px;
        width: 220px;
    }

    .addileft {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        flex-shrink: 0;
    }

    .addileft img {
        width: 100%;
        height: 100%;
    }

    .addressContent {}

    .accolki {
        flex-wrap: wrap;
        justify-content: space-between;
        max-height: 500px;
        overflow-y: auto;
    }

    .addressItem {
        width: 296px;
        height: 103px;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        box-sizing: border-box;
        padding: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        position: relative;
    }

    .addressItem:hover .addressmask {
        width: 100%;
        height: 32px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 0px 0px 9px 9px;
        box-sizing: border-box;
        padding: 0 16px;
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
    }


    .tabItem {
        font-weight: 500;
        font-size: 16px;
        color: #414141;
        padding: 0 0 8px 0;
        margin-right: 26px;
        border-bottom: 2px solid transparent;
        cursor: pointer;
    }

    .tabAc {
        border-bottom: 2px solid #007AFF !important;
        color: #007AFF !important;
    }

    .addressLeft {
        flex-shrink: 0;
        margin-right: 4px;
        position: relative;
        top: 3px;
    }

    .addressRight {
        flex: 1
    }

    .alt {
        font-weight: 600;
        font-size: 16px;
        color: #333333;
    }

    .alb {
        font-size: 14px;
        color: #666666;
    }

    .addressLeft img {
        width: 18px;
        height: 18px;
    }

    .sdleft {
        font-size: 16px;
        color: #333333;
        line-height: 21px;
    }

    .sdright {
        font-size: 16px;
        color: #333333;
        line-height: 21px;
        flex: 1;
        text-align: right;
    }

    .sdright input {
        width: 100%;
        height: 100%;
        border: none !important;
        outline: none !important;
        font-size: 16px;
        box-sizing: border-box;
        padding-left: 20px;
        text-align: right;
    }

    .orderspecs {
        margin-top: 12px;
    }

    .sendmethod {
        padding: 26px 0;
        border-bottom: 1px solid #f6f6f6;
    }

    .orderImg {
        width: 110px;
        height: 110px;
        flex-shrink: 0;
        margin-right: 16px;
    }

    .orderImg img {
        width: 100%;
        height: 100%;
    }

    .subbtn {
        width: 100%;
        height: 48px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 48px;
        font-weight: 600;
        font-size: 14px;
        color: #FFFFFF;
    }

    .payItem {
        width: 255px;
        height: 72px;
        border-radius: 10px;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        padding: 0 18px;
        margin-top: 18px;
    }

    .payItem img {
        width: 40px;
        height: 40px;
    }

    .totalPrice {
        justify-content: flex-end;
        color: #000;
        font-size: 16px
    }

    .goodsPrice {
        padding: 20px 0;
        border-bottom: 1px solid #f6f6f6;
    }

    .orderTitle {
        font-size: 18px;
        color: #000000;
    }

    .orderDes {
        font-size: 12px;
        color: #919296;
        margin-top: 12px;
    }

    .orderName {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        width: 100%;
    }

    .orderPrices {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
    }

    .orderPrice {
        font-weight: 600;
        flex: 1;
        font-size: 16px;
        color: #000000;
        text-align: right !important;
    }

    .part {
        width: 100%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 20px 16px;
        margin-bottom: 16px;
    }

    /* vue2 使用 /deep/ 穿透 scoped */
    /deep/ .el-dialog {
        border-radius: 10px;
        /* 整体圆角大小，自行调整 6px/8px/12px/16px */
        overflow: hidden;
        /* 关键：内部内容不会溢出圆角 */
        background: #F3F5F9;
    }

    .speccon {
        border-bottom: 1px solid #ebebeb;
        margin-bottom: 30px;
    }

    .bunybtn {
        width: 220px;
        height: 52px;
        background: #007AFF;
        border-radius: 10px;
        text-align: center;
        line-height: 52px;
        font-size: 16px;
        color: #FFFFFF;
        margin-left: 80px;
    }

    .fcAc {
        border: 1px solid #007AFF !important;
        color: #007AFF !important;
    }

    .spname {
        font-size: 14px;
        color: #888B93;
        line-height: 21px;
    }

    .specit {
        height: 35px;
        background: #F6F7FC;
        border-radius: 4px;
        line-height: 35px;
        font-size: 14px;
        color: #1A1A1A;
        margin-right: 10px;
        padding: 0 14px;
        margin-top: 16px;
        border: 1px solid #F6F7FC;
    }

    .specCon {
        flex-wrap: wrap;
    }

    .specItem {
        padding: 16px 0;
    }

    .redetail {
        box-sizing: border-box;
        padding: 12px 0;
    }

    .rename {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        margin-bottom: 10px;
    }

    .bbtitle {
        font-weight: 600;
        margin-bottom: 20px;
        font-size: 24px;
        color: #000000;
    }

    .bookItem {
        width: 198px;

    }

    .reImge img {
        width: 100%;
        height: 100%;
    }

    .reImge {
        width: 198px;
        height: 198px;
    }

    .price-box {
        display: inline-flex;
        align-items: baseline;
        color: #FF0F23;
    }

    .int {
        font-size: 22px;
        font-weight: bold;
    }

    .dec {
        font-size: 17px;
    }

    .bookBottom {
        width: 100%;
        margin-top: 16px;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 20px;
        background: #fff;

    }

    .ips {
        border-top: 1px solid #EBEBEB;
        margin-top: 16px;
    }

    .ipitem {}

    .ipright {
        flex: 1;
        border-bottom: 1px solid #EBEBEB;
        box-sizing: border-box;
        padding: 16px 0;
    }

    .ipitem img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .prices {
        align-items: baseline;
        margin-top: 22px;
    }

    .oprice {
        font-weight: 600;
        font-size: 28px;
        color: #FF0F23;
        margin-right: 12px;
    }

    .linprice {
        font-size: 20px;
        color: #B6B6B6;
        text-decoration: line-through;
    }

    .bookName {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
    }

    .bookTop {
        box-sizing: border-box;
        padding: 24px 18px;
        background: #fff;
        border-radius: 10px;
    }

    .bookRight {
        width: 448px;
    }

    .book-swiper-container {
        width: 100%;
        border-radius: 10px;
    }

    /* 左侧缩略图容器 */
    .thumb-list {
        display: flex;
        flex-direction: column;
        margin-right: 20px;
        width: 112px;
    }

    /* 单个缩略图 */
    .thumb-item {
        width: 100%;
        height: 112px;
        border: 2px solid transparent;
        cursor: pointer;
        overflow: hidden;
    }

    /* 选中高亮蓝色边框（匹配效果图蓝色框） */
    .thumb-item.active {
        border-color: #409eff;
    }

    .thumb-item .el-image {
        width: 100%;
        height: 100%;
    }

    /* 覆盖element轮播默认样式微调 */
    /deep/ .el-carousel__container {
        background: #fff;
    }

    .bookLeft {
        width: 992px
    }

    .subbtn {
        width: 100%;
        height: 48px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 48px;
        font-weight: 600;
        font-size: 14px;
        color: #FFFFFF;
    }

    .payItem {
        width: 255px;
        height: 72px;
        border-radius: 10px;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        padding: 0 18px;
        margin-top: 18px;
    }

    .totalPrice {
        justify-content: flex-end;
        color: #000;
        font-size: 16px
    }

    .goodsPrice {
        padding: 20px 0;
        border-bottom: 1px solid #f6f6f6;
    }

    .orderTitle {
        font-size: 18px;
        color: #000000;
    }

    .orderDes {
        font-size: 12px;
        color: #919296;
        margin-top: 12px;
    }

    /*  .orderName {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        width: 80%;
    } */

    .orderPrice {
        font-weight: 600;
        flex: 1;
        font-size: 16px;
        color: #000000;
        text-align: right !important;
    }

    .part {
        width: 100%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 20px 16px;
        margin-bottom: 16px;
    }

    /* vue2 使用 /deep/ 穿透 scoped */
    /deep/ .el-dialog {
        border-radius: 10px;
        /* 整体圆角大小，自行调整 6px/8px/12px/16px */
        overflow: hidden;
        /* 关键：内部内容不会溢出圆角 */
        background: #F3F5F9;
    }

    .reTitle {
        font-size: 14px;
        color: #919296;
    }

    .readdress {
        font-size: 12px;
        color: #007AFF;
        line-height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        background: #F4F9FF;
        display: inline-block;
        margin-bottom: 10px;

    }

    .reName {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 14px;
    }

    .reItem {
        width: 100%;
        border-bottom: 1px solid #ececec;
        margin-bottom: 20px;
    }

    .reInfo {
        text-align: left;
        box-sizing: border-box;
        padding: 12px 0 20px;
    }

    .reImg {
        width: 292px;
        height: 164px;

    }

    .reImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }

    .bpt {
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 20px;
        text-align: left;
    }

    .bottomPart {
        background: #ffffff;
        width: 332px;
        box-sizing: border-box;
        padding: 20px;
    }

    .price1 {
        font-weight: 500;
        font-size: 24px;
        color: #EC1414;
        margin-right: 12px;
    }

    .price2 {
        font-size: 18px;
        color: #B1B5B9;
        text-decoration-line: line-through;
        text-transform: none;
    }

    .infname {
        font-weight: 500;
        font-size: 14px;
        color: #888B93;
        margin-right: 14px;
        line-height: 42px;
        width: 56px;
    }

    .acD /deep/ img {
        width: 100%;
        height: auto;
    }

    .lades {
        width: 900px;
        font-size: 14px;
        color: #919296;
        margin-bottom: 24px;
    }

    .labels {
        margin-bottom: 14px;
    }

    .label {
        height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        font-size: 12px;
        color: #007AFF;
        background: #F4F9FF;
        border-radius: 1px 1px 1px 1px;
        line-height: 19px;
        margin-right: 8px;
    }

    .tickets {
        flex-wrap: wrap;
        width: 500px;
    }

    .ticketPrice {
        font-weight: 500;
        font-size: 16px;
        color: #FF0F23;
        margin-right: 6px;
    }

    .ticketName {
        font-size: 12px;
        color: #666666;
    }

    .ticketItem img {
        position: absolute;
        right: 0;
        bottom: 0;
        margin-right: 0 !important;
    }

    .ticketItem {
        margin-bottom: 20px;
        height: 42px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #D9D9D9;
        box-sizing: border-box;
        padding: 10px 20px;
        margin-right: 14px;
        position: relative;
        flex-shrink: 0;
    }

    .comDes {
        font-size: 14px;
        color: #6D6D6D;
        margin-top: 12px;
    }

    .acfocus {
        width: 68px;
        height: 38px;
        border-radius: 19px;
        border: 1px solid rgba(64, 150, 255, 1);
        text-align: center;
        line-height: 38px;
        font-size: 15px;
        color: #007AFF;
        font-weight: 500;
    }

    .unfocus {
        width: 68px;
        height: 38px;
        border-radius: 19px;
        color: #fff;
        text-align: center;
        line-height: 38px;
        font-size: 15px;
        background: #007AFF;
        font-weight: 500;
    }

    .cominfo {
        flex: 1;
    }

    .cominfo img {
        width: 14px;
        height: 14px;
    }

    .comTitle {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 8px;
    }

    .comImg {
        width: 60px;
        height: 60px;
        margin-right: 12px;
    }

    .comImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        margin-right: 12px;
        object-fit: cover;
    }

    .compart {
        width: 100%;
        background: #F7F8F9;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 20px;

    }

    .bheng {
        width: 24px;
        height: 4px;
        background: #007AFF;
        margin: 0 auto;
        margin-top: 8px;
    }

    .actitles {
        display: inline-block;
        position: relative;
        margin-bottom: 20px;
    }

    .actName {
        font-weight: 500;
        font-size: 18px;
        color: #3C464F;

    }

    .acintro {
        background-color: #fff;
        box-sizing: border-box;
        padding: 26px;
        text-align: left;
    }

    .tipLeft {
        width: 100%;
        margin-top: 16px;
    }

    .buytip {
        text-align: left;
        width: 100%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 26px;
    }

    .actips {
        margin-top: 16px;
    }

    .btns {
        margin-top: 26px;
        box-sizing: border-box;
        padding-left: 433px;
    }

    .btnRight i {
        margin-right: 6px;
    }

    .btnRight {
        width: 130px;
        height: 40px;
        border-radius: 8px;
        border: 1px solid rgba(64, 150, 255, 1);
        justify-content: center;
        font-weight: 600;
        font-size: 14px;
        color: #007AFF;
    }

    .btnLeft {
        width: 280px;
        height: 40px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
    }

    .freePart {
        width: 48px;
        height: 26px;
        background: #EFF6FF;
        border-radius: 13px;
        font-size: 12px;
        color: #1E40AF;
        text-align: center;
        line-height: 26px;
    }

    .acNames {
        margin-bottom: 22px;
    }

    .infItem span {
        font-size: 14px;
        color: #1F2937;
    }

    .infItem {
        margin-bottom: 16px;
    }

    .infItem img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .buyItem {
        font-size: 14px;
        margin-left: 18px;
    }

    .buyItem img {
        width: 20px;
        height: 20px;
    }

    .buyItem span {
        margin-left: 4px;
    }

    .acName {
        font-weight: 600;
        font-size: 18px;
    }

    .acInfo {
        flex: 1;
    }

    .acImg {
        width: 344px;
        height: 194px;
        margin-right: 20px;
        flex-shrink: 0;
    }

    .acImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        object-fit: cover;
    }

    .acTivitiesDetail {
        width: 100%;
        background: #fff;
        box-sizing: border-box;
        padding: 26px;
    }

    .cons {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 0;
        border-radius: 10px;
        text-align: left
    }
</style>